// Sidebar header — brand logo + collapse toggle.
// iter-156 (Phase 8): the Aspire "Connected / Synced X ago" pill + sidebar
// sync button were removed. With the auto-on-mount full sync retired, a
// sidebar sync affordance was deceiving (it implied navigation kept data
// fresh). Aspire connection status + the manual "Full Sync" escape hatch
// now live in Settings → Aspire Integration.

import {
  ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon,
} from 'lucide-react';

function CollapseToggle({ collapsed, onToggle }) {
  return (
    <button
      data-testid="sidebar-collapse-toggle"
      type="button"
      onClick={onToggle}
      className="hidden lg:flex absolute -right-3 top-5 w-6 h-6 rounded-full items-center justify-center z-10 transition-colors"
      style={{
        background: 'var(--strata-card, #FFFFFF)',
        border: '1px solid var(--strata-border, #D5D8DD)',
        color: 'var(--strata-text-secondary, #5C6370)',
        boxShadow: '0 1px 4px rgba(15,21,32,0.10)',
      }}
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
    >
      {collapsed
        ? <ChevronRightIcon className="w-3.5 h-3.5" />
        : <ChevronLeftIcon className="w-3.5 h-3.5" />}
    </button>
  );
}

function BrandMark({ collapsed, companyName }) {
  if (collapsed) {
    // Collapsed default: just the X mark, centred on the rail.
    return (
      <div className="flex justify-center">
        <img
          src="/brand/icon_mark.svg"
          alt="Strata x Framework"
          style={{ height: 64, width: 64, filter: 'brightness(0) invert(1)' }}
        />
      </div>
    );
  }
  // Expanded default: horizontal primary logo (wider artwork reads
  // better in the narrow sidebar than the square secondary mark).
  // iter-154r: the Strata mark is ALWAYS shown at the top now — the
  // company's own logo lives in the bottom user-info area.
  return (
    <div className="flex flex-col items-start gap-2">
      <img
        src="/brand/primary_logo.svg"
        alt="Strata x Framework"
        style={{ height: 88, width: 'auto', maxWidth: '100%', filter: 'brightness(0) invert(1)' }}
      />
      {companyName && (
        <p
          className="text-[9px] uppercase tracking-[0.2em] truncate w-full"
          style={{ color: 'var(--strata-sidebar-text)', fontFamily: 'var(--strata-font-body)' }}
        >
          {companyName}
        </p>
      )}
    </div>
  );
}

export function SidebarHeader({ collapsed, onToggle, user }) {
  return (
    <div
      className={`relative ${collapsed ? 'px-3 py-3' : 'px-5 py-4'}`}
      style={{ borderBottom: '1px solid var(--strata-sidebar-border)' }}
    >
      <CollapseToggle collapsed={collapsed} onToggle={onToggle} />
      <BrandMark collapsed={collapsed} companyName={user?.company_name} />
    </div>
  );
}
